module.exports = __webpack_public_path__ + "static/img/RWA466-G_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RWA466-G_1.png
// module id = YPks
// module chunks = 0